import { render, staticRenderFns } from "./InputInfoItem.vue?vue&type=template&id=2ad81194&scoped=true&"
import script from "./InputInfoItem.vue?vue&type=script&lang=js&"
export * from "./InputInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./InputInfoItem.vue?vue&type=style&index=0&id=2ad81194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad81194",
  null
  
)

export default component.exports